// extracted by mini-css-extract-plugin
module.exports = {"style":"style___Majsz","title":"title___1EVoa","title2":"title2___3Pt4j","tip":"tip___2dY7T","url":"url___3eTts","link":"link___2ttNL"};